import React, { useEffect } from "react";
import { Form, Input, InputNumber, Switch, Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
const TaxRateFormModal = ({ onCancel, initialData, isEdit, onSubmit, loading }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  useEffect(() => {
    if (initialData && isEdit) {
      form.setFieldsValue({
        ...initialData,
        taxPercent: initialData.taxPercent ? initialData.taxPercent * 100 : initialData.taxPercent,
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ taxIsActive: true });
    }
  }, [initialData, isEdit, form]);

  const handleFinish = (values) => {
    const formatted = {
      ...values,
      taxIsActive: values.taxIsActive ?? true,
      taxPercent: values.taxPercent ? values.taxPercent / 100 : values.taxPercent,
    };
    onSubmit(formatted);
    onCancel();
  };

  return (
    <div className="card table-list-card">
      <div
        className="d-flex align-items-center justify-content-between px-4 py-3"
        style={{ background: 'var(--primary-gradient)', borderRadius: "8px 8px 0 0" }}
      >
        <h4 className="text-white mb-0">{isEdit ? t("taxes.editTaxRate") : t("taxes.addTaxRate")}</h4>
        <div className="d-flex gap-2">
          <Button onClick={onCancel}>{t("common.cancel")}</Button>
          <Button loading={loading} type="primary" onClick={() => form.submit()}>
            {isEdit ? t("common.save") : t("common.add")}
          </Button>
        </div>
      </div>

      <div className="card-body p-4">
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            name="taxName"
            label={t("taxes.taxName")}
            rules={[{ required: true, message: t("taxes.requiredName") }]}
          >
            <Input placeholder="Ex: TVA" />
          </Form.Item>

          <Form.Item name="taxAmount" label={t("taxes.fixedAmount")}>
            <InputNumber min={0} style={{ width: "100%" }} placeholder="Ex: 100" />
          </Form.Item>

          <Form.Item name="taxPercent" label={t("taxes.percentage")}>
            <InputNumber min={0} max={100} style={{ width: "100%" }} placeholder="Ex: 20" />
          </Form.Item>

          <Form.Item layout="horizontal" name="taxIsActive" label={t("taxes.status")} valuePropName="checked">
            <Switch defaultChecked />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

TaxRateFormModal.displayName = "TaxRateFormModal";

TaxRateFormModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  isEdit: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default TaxRateFormModal;